import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'debounce';

import classNames from './../../utils/classNames';
import Dropdown from './../Dropdown';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'phone';

class PhoneDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: ''
        };

        this.onChange = this.onChange.bind(this);
        this.debounceSave = debounce(this.debounceSave, 1000);
    }

    onChange(event) {
        const inputValue = event.target.value;
        this.setState({ inputValue });
        const { save } = this.props;
        this.debounceSave(inputValue, save);
    }

    debounceSave(value, method) {
        method(value);
    }

    componentDidMount() {
        const { value } = this.props;
        this.setState({ inputValue: value });
    }

    render() {
        const { inputValue } = this.state;
        const { phoneVerified } = this.props;
        const text = inputValue || 'Enter phone';
        const buttonClassName = classNames('lnk-dropdown', { 'text-warning': !phoneVerified });
        return (
            <Dropdown buttonClassName={buttonClassName} text={text} title={text}>
                <input className="input-text" type="tel" maxLength="100" onChange={this.onChange} autoFocus value={inputValue} placeholder="Enter your phone" />
            </Dropdown>
        );
    }
}

const mapStateToProps = state => ({
    value: state.user[fieldName],
    phoneVerified: state.user.phone_number_status === 'Verified',
});

const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/PhoneDropdown.js